export default {"src":"/_next/static/media/logo-SGX-vector-white.1c2ff83f.svg","height":70,"width":167,"blurWidth":0,"blurHeight":0};